import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { BaseComponent } from 'belle-js'
import NameHeader from 'components/Client/NameHeader/NameHeader'
import Subnavigation from '../Subnavigation/Subnavigation'
import SubnavigationItem from '../Subnavigation/SubnavigationItem'
import DocumentList from '../DocumentList/DocumentList'
import withTechnicalDifficultiesErrorMessage from 'components/Client/withTechnicalDifficultiesErrorMessage'
import withLoadingState from '../withLoadingState'
import LoadingComponent from 'components/Client/LoadingComponent/LoadingComponent'
import {
  CLIENT_UPLOADER
} from 'utils/Client/urlPaths'
import {
  formatDocuments,
  getURLFromTabLabel,
  getActiveTab,
  documentTabConfig,
  findTabConfig
} from 'utils/Client/documents'

class DocumentsPage extends BaseComponent {

  constructor (props) {
    super(props)
    this.state = {}

    this.bind('handleItemSelected')
  }

  handleItemSelected (label) {
    const {
      goDocumentsSubSection
    } = this.props

    goDocumentsSubSection(getURLFromTabLabel(label))
  }

  flatDocuments (docs) {
    return [].concat(...docs)
  }

  getDocumentsByType (type) {
    const {
      myUploadedDocs,
      sharedWithMeDocs,
    } = this.props
    const myUploadsLabel = documentTabConfig.myUploads.label === type
    if (myUploadsLabel) return this.flatDocuments(Object.values(myUploadedDocs))
    const tabLabel = findTabConfig('label', type).label

    return sharedWithMeDocs[tabLabel] || []
  }

  renderDocumentsIfTabSelected (activeTabLabel, label) {
    if (activeTabLabel === label) return this.renderDocumentsListByType(activeTabLabel)
    return
  }

  renderDocumentsListByType (type) {
    const {
      isMobile,
      loadingDocuments,
      boxError
    } = this.props
    const docs = this.getDocumentsByType(type)
    const shouldRenderSubFolderHeader = documentTabConfig.myUploads.label !== type

    const DocumentListComponent = (
      <DocumentList
        isMobile={isMobile}
        shouldRenderSubFolderHeader={shouldRenderSubFolderHeader}
        documents={formatDocuments(docs)}
        documentType={type} />
    )
    const DocumentsListWithLoading = withLoadingState(DocumentListComponent, <LoadingComponent />)
    const DocumentListComponents = <DocumentsListWithLoading loading={loadingDocuments} />
    const DocumentListContent = withTechnicalDifficultiesErrorMessage(DocumentListComponents)

    return (
      <DocumentListContent
        showError={boxError}
        context="documents"
        layout="page" />
    )
  }

  render () {
    const {
      location: {
        payload: { documentListType }
      },
      clientExperience,
      user: { fullName }
    } = this.props

    const {
      myUploads: { label: myUploadsLabel,  path: myUploadsPath },
      sharedWithMe: { label: sharedWithMeLabel },
      statements: { label: statementsLabel },
      taxForms: { label:  taxFormsLabel },
      proposals: { label:  proposalsLabel },
      other: { label:  otherLabel },
      alternatives: { label: alternativesLabel },
    } = documentTabConfig
    const displayUploadButton = documentListType === myUploadsPath
    const activeTabLabel = getActiveTab(documentListType)

    return (
      <Fragment>
        <NameHeader name={fullName} />
        <Subnavigation
          activeTab={activeTabLabel}
          onItemSelected={this.handleItemSelected}>
          <SubnavigationItem label={myUploadsLabel}>
            { this.renderDocumentsIfTabSelected(activeTabLabel, myUploadsLabel)}
          </SubnavigationItem>
          <SubnavigationItem
            label={sharedWithMeLabel}
            isDropdown={true}>
            {
              clientExperience &&
              <Fragment>
                <SubnavigationItem
                  activeTab={activeTabLabel}
                  label={statementsLabel}>
                  { this.renderDocumentsIfTabSelected(activeTabLabel, statementsLabel)}
                </SubnavigationItem>
                <SubnavigationItem
                  activeTab={activeTabLabel}
                  label={taxFormsLabel}>
                  { this.renderDocumentsIfTabSelected(activeTabLabel, taxFormsLabel)}
                </SubnavigationItem>
              </Fragment>
            }
            <SubnavigationItem
              activeTab={activeTabLabel}
              label={proposalsLabel}>
              { this.renderDocumentsIfTabSelected(activeTabLabel, proposalsLabel)}
            </SubnavigationItem>
            <SubnavigationItem
              activeTab={activeTabLabel}
              label={alternativesLabel}>
              { this.renderDocumentsIfTabSelected(activeTabLabel, alternativesLabel)}
            </SubnavigationItem>
            <SubnavigationItem
              activeTab={activeTabLabel}
              label={otherLabel}>
              { this.renderDocumentsIfTabSelected(activeTabLabel, otherLabel)}
            </SubnavigationItem>
          </SubnavigationItem>
          <SubnavigationItem
            display={displayUploadButton}
            highlightButton={true}
            buttonText="Upload Document"
            route={CLIENT_UPLOADER}
            text="Secure Document Upload" />
        </Subnavigation>
      </Fragment>
    )
  }

}

DocumentsPage.defaultProps = {
  goDocumentsSubSection: () => {},
  user: {},
  myUploadedDocs: {},
  sharedWithMeDocs: {}
}

DocumentsPage.propTypes = {
  goDocumentsSubSection: PropTypes.func,
  location: PropTypes.object.isRequired,
  user: PropTypes.object,
  myUploadedDocs: PropTypes.object,
  sharedWithMeDocs: PropTypes.object
}

export default DocumentsPage



// WEBPACK FOOTER //
// ./src/components/Client/DocumentsPage/DocumentsPage.jsx